import ProfileVue from '@/views/sm/profile/profile.vue';

const basePath = '/sm/profile';
const role = 'sm'; // 角色身份

export const SM_PROFILE_INDEX = 'sm-profile-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ProfileVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SM_PROFILE_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/profile/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
